import React from "react";

function AdminReports() {
  return <div>AdminReports</div>;
}

export default AdminReports;
